"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var i0 = require("./route-search-results.component.css.shim.ngstyle");
var i1 = require("@angular/core");
var i2 = require("../search-results/search-results.component.ngfactory");
var i3 = require("../search-results/search-results.component");
var i4 = require("../../Services/service.service");
var i5 = require("../../Services/geolocation.service");
var i6 = require("../../Services/searchroute.service");
var i7 = require("../../api/WickedApiClient");
var i8 = require("@angular/router");
var i9 = require("./route-search-results.component");
var i10 = require("../../Services/seo.service");
var styles_RouteSeachResults = [i0.styles];
var RenderType_RouteSeachResults = i1.ɵcrt({ encapsulation: 0, styles: styles_RouteSeachResults, data: {} });
exports.RenderType_RouteSeachResults = RenderType_RouteSeachResults;
function View_RouteSeachResults_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-search-results", [], null, null, null, i2.View_SearchResultsComponent_0, i2.RenderType_SearchResultsComponent)), i1.ɵdid(1, 245760, null, 0, i3.SearchResultsComponent, [i4.MainService, i5.GeolocationService, i6.SearchRouteService, i7.AdveristmentsClient, i8.Router, i8.ActivatedRoute], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
exports.View_RouteSeachResults_0 = View_RouteSeachResults_0;
function View_RouteSeachResults_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-route-search-results", [], null, null, null, View_RouteSeachResults_0, RenderType_RouteSeachResults)), i1.ɵdid(1, 245760, null, 0, i9.RouteSeachResults, [i4.MainService, i8.ActivatedRoute, i7.AdveristmentsClient, i10.SeoService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
exports.View_RouteSeachResults_Host_0 = View_RouteSeachResults_Host_0;
var RouteSeachResultsNgFactory = i1.ɵccf("app-route-search-results", i9.RouteSeachResults, View_RouteSeachResults_Host_0, {}, {}, []);
exports.RouteSeachResultsNgFactory = RouteSeachResultsNgFactory;
